module.exports = __webpack_public_path__ + "static/media/foto 1 exalcalde noe villavicencio detenido.efa1171a.jpg";